(function() {

    'use strict';

    /**
     * @module Plugins
     *
     * Subscribes roll info (published by VAST plugin) and takes care of sending KPIs and going back to main video.
     *
     * @namespace sv_rolls
     */

    /**
     * Used internally to make sv_roll plugin listen to VAST info.
     *
     * @function roll_info
     * @param {String} messageKind='roll_info'
     * @param {Object} o
     * @param {String} o.requestURL request video URL for ad
     * @param {Object} o.roll       roll information
     * @param {String} o.rollname   pre|mid|pos
     */



    var _       = SAPO.Project.Video._,
        Element = SAPO.Dom.Element,
        Event   = SAPO.Dom.Event,
        Feat    = SAPO.Project.Video.Features;

    var aClickCbBound;

    var clone = function(o) {
        return JSON.parse( JSON.stringify(o) );
    };

    var aClickCb = function(ev) {

        //window.top.log('SV_ROLLS EVENT HANDLER (a) type: '+ev.type);

        var tgtEl = ev && Event.element(ev);
        if (Element.findUpwardsByClass(tgtEl, 'ad-skip')) {
            // console.log('AD SKIPPED');
            //this._ui._els.aEl.href = 'javascript:void(0)';
            this._ui._els.aEl.removeAttribute('href');
            this._ui._els.aEl.removeAttribute('rel');
            this._ui._els.aEl.target = '';
            try {
                this._pub('metro', this._bag.tracking.skip, 'vast_skip');
            } catch (ex) {} // TODO CHECK TRY IS RELEVANT
            return this._pub('invalidate_ad_roll', {autoplay:true});
        }

        // console.log('GOING TO CLICK TRACKING...');

        setTimeout(function() {
            //window.top.log('REMOVING EVENTS AND HREF');

            Event.stopObserving(this._ui._els.aEl, 'click', aClickCbBound);
            /*Event.stopObserving(this._ui._els.aEl, 'mouseup', aClickCbBound);
            if (Feat.hasTouchEvents) {
                Event.stopObserving(this._ui._els.aEl, 'touchend', aClickCbBound);
            }*/

            if (Feat.isIOS) {
                try {
                    this._vc.unload();
                } catch (ex) {
                    //console.log(ex);
                }
            }

            //LOG('A: clicked, restoring');

            // this._ui._els.aEl.href = 'javascript:void(0)';
            this._ui._els.aEl.removeAttribute('href');
            this._ui._els.aEl.removeAttribute('rel');
            this._ui._els.aEl.removeAttribute('title');
            this._ui._els.aEl.target = '';

            //LOG( 'BAG:<br/><pre>' + JSON.stringify(this._bag, null, '  ') + '</pre>' );
            this._pub('metro', this._bag.videoClicks.tracking, 'vast_clickTracking');
            this._vc.pause();
            //LOG('request_load ' + this._backToVideoURI);

            /*if (SAPO.Browser.IE && parseInt(SAPO.Browser.version, 10) < 9) {
                var u = this._bag.videoClicks.through;
                if (u) { u = u[0]; }
                if (u) {
                    window.parent.location.href = u;
                }
            }*/
            //else {
                this._pub('invalidate_ad_roll', {autoplay:false});
            //}

        }.bindObj(this), 0);

        if (SAPO.Browser.IE && parseInt(SAPO.Browser.version, 10) < 9) {
            window.open(this._bag.videoClicks.through);
        }
    };




    var plugin = function(vc, ui, pub, pubD) {
        this._vc = vc;
        this._ui = ui;
        this._pub = pub;
        this._pubD = pubD;
        this._inAd = false;

        this._bags = {};
        this._bag = {
            tracking: {}
        };

        aClickCbBound = aClickCb.bindObj(this);

        this._vc.subscribe('before_unload h_mute h_resize h_state_changed load metadata_changed roll_info state_changed', undefined, this);
    };

    plugin.prototype = {

        _name: plugin._name = 'sv_rolls',

        on: function(mt) {
            /*jshint maxcomplexity:40, scripturl:true */

            var originalArgs = Array.prototype.slice.call(arguments);
            var args = originalArgs.slice(); args.shift();
            var a0 = args[0];

            var bag = this._bag;
            var bagT = bag.tracking;
            var t;

            /*console.log(
                'IN AD? %s | BAG %s | BAGT %s',
                this._inAd ? 'Y' : 'N',
                ('impression' in bag) ? 'Y':'N',
                Object.keys(bagT).length
            );*/

            // early returns, for events not dependent on being inside an ad...
            switch (mt) {
                case 'metadata_changed':
                    if (a0.fullURI !== this._currVideoURI) {
                        this._backToVideoURI = this._currVideoURI;
                    }
                    this._currVideoURI = a0.requestURL;
                    return;

                case 'roll_info':
                    //console.log('roll_info %s : %s', a0.rollRequestURL, JSON.stringify(a0.roll, null, '  ') );
                    //console.log('roll_info');
                    this._bags[ a0.rollRequestURL ] = clone(a0.roll);
                    return;

                case 'load':
                    this._vc._clickEl.style.cursor = '';
                    this._vc._clickEl.title = '';

                    //console.log('SV_ROLLS_ load: %s -> %s', this._backToVideoURI || '', this._currVideoURI);

                    var o = this._bags[ a0.requestURL ];
                    if (!o) {
                        o = { tracking: {} };
                    }
                    //console.log('rolls load:', o);
                    bag = o;
                    bagT = bag.tracking;
                    this._bag = o;

                    this._inAd = a0.isAd;

                    if (this._inAd && bag.videoClicks && bag.videoClicks.through && bag.videoClicks.through.length > 0) {
                        //console.log('LOAD ROLL: ' + bag.stage);

                        if (!Feat.isIPhoneOrIPod) { // iPhones should not display adwords nor do clickTracking
                            setTimeout(function() {
                                //window.top.log('FIRED FROM TIMEOUT', bag.videoClicks.through[0]);
                                this._ui._els.aEl.href = bag.videoClicks.through[0];
                                this._ui._els.aEl.target = '_blank';
                                this._ui._els.aEl.setAttribute('rel', 'external');

                                Event.observe(this._ui._els.aEl, 'click', aClickCbBound); // IPAD SEENS TO REQUIRE THIS
                                /*Event.observe(this._ui._els.aEl, 'mouseup', aClickCbBound);
                                if (Feat.hasTouchEvents) {
                                    Event.observe(this._ui._els.aEl, 'touchend', aClickCbBound);
                                }*/
                            }.bindObj(this), 0);
                        }

                        this._vc._clickEl.style.cursor = 'pointer';
                        this._vc._clickEl.title = _('adTitle');
                    }
                    else {
                        Event.stopObserving(this._ui._els.aEl, 'click', aClickCbBound);
                        /*Event.stopObserving(this._ui._els.aEl, 'mouseup', aClickCbBound);
                        if (Feat.hasTouchEvents) {
                            Event.stopObserving(this._ui._els.aEl, 'touchend', aClickCbBound);
                        }*/

                        this._ui._els.aEl.removeAttribute('rel');
                        this._ui._els.aEl.removeAttribute('href');
                        this._ui._els.aEl.target = '';
                        // this._ui._els.aEl.href = 'javascript:void(0)';
                    }
                    return;
            }

            // from here on, events requiring handling must be in an ad
            if (!this._inAd) { return; }

            switch (mt) {
                case 'before_unload':
                    this._pub('metro', bagT.close,       'vast_close');
                    this._pub('metro', bagT.closeLinear, 'vast_closeLinear');
                    break;

                case 'state_changed': // SEND IMPRESSION
                    if( bag && bag.impression && bag.impression.length > 0) {
                        this._pub('metro', bag.impression, 'vast_linear_' + bag.stage + '_impression');
                        bag.impression = [];
                    }
                    break;

                case 'h_mute':
                    //console.log('h_mute', a0);
                    t = (a0 ? 'mute' : 'unmute');
                    this._pub('metro', bagT[t], 'vast_' + t);
                    break;

                case 'h_resize':
                    //console.log('h_resize', a0);
                    t = (a0 === 'full' ? 'expand' : 'collapse');
                    this._pub('metro', bagT[t], 'vast_' + t);
                    break;

                case 'h_state_changed':
                    //console.log('h_state_changed', a0);
                    t = (a0 === 'play' ? 'resume' : 'pause');
                    this._pub('metro', bagT[t], 'vast_' + t);
                    break;
            }
        }
    };

    SAPO.Project.Video.Controllers._plugins.push(plugin);

})(undefined);
